/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: ITAT Time
==========================================================================================*/


export default [
  {
    url: '/tasks',
    name: 'My Tasks',
    slug: 'Tasks',
    icon: 'ListIcon',
    clientVisibility: false,
    requiresAdminAccess: false,
    active: true
  },
  {
    url: '/timeEntries',
    name: 'Time Entries',
    slug: 'timeEntries',
    icon: 'ClockIcon',
    clientVisibility: false,
    requiresAdminAccess: false,
    active: true
  },
  {
    url: '/dailyTime',
    name: 'Daily Time',
    slug: 'dailyTime',
    icon: 'CalendarIcon',
    clientVisibility: false,
    requiresAdminAccess: true,
    active: true
  },
  // {
  //   url: "/dashboard",
  //   name: "Dashboard",
  //   slug: "dashboard",
  //   icon: "LayoutIcon",
  //   clientVisibility: true,
  //   requiresAdminAccess: false,
  //   active: true
  // },
  {
    url: '/projects',
    name: 'Projects',
    slug: 'projects',
    icon: 'FolderIcon',
    clientVisibility: true,
    requiresAdminAccess: false,
    active: true
  },
  // {
  //   url: '/projectsWorker',
  //   name: 'All Projects',
  //   slug: 'projectsWorker',
  //   icon: 'FolderIcon',
  //   clientVisibility: false,
  //   requiresAdminAccess: false,
  //   active: true
  // },
  {
    url: '/sow-maintenance',
    name: 'SOW Admin',
    slug: 'projectsWorker',
    icon: 'CompassIcon',
    clientVisibility: false,
    requiresAdminAccess: true,
    active: true
  },
  // {
  //   url: '/taskAssignment',
  //   name: 'Tasks',
  //   slug: 'taskAssignment',
  //   icon: 'ListIcon',
  //   clientVisibility: false,
  //   requiresAdminAccess: true,
  //   active: true,
  //   style: 'margin-left: auto;'
  // },
  {
    url: '/clients',
    name: 'Clients',
    slug: 'clients',
    icon: 'UsersIcon',
    clientVisibility: false,
    requiresAdminAccess: true,
    active: true,
    style: 'margin-left: auto;'
  },
  {
    url: '/workers',
    name: 'Workers',
    slug: 'workers',
    icon: 'UsersIcon',
    clientVisibility: false,
    requiresAdminAccess: true,
    active: true
  },
  {
    url: '/reports',
    name: 'Reports',
    slug: 'workers',
    icon: 'BookIcon',
    clientVisibility: false,
    requiresAdminAccess: true,
    active: true
  }
  // {
  //   url: "/Invoicing",
  //   name: "Invoicing",
  //   slug: "invoicing",
  //   icon: "CreditCardIcon",
  //   clientVisibility: true,
  //   requiresAdminAccess: false,
  //   active: true
  // },

]
